import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=27c91f7a&scoped=true"
import script from "./ProductStock.vue?vue&type=script&lang=js"
export * from "./ProductStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c91f7a",
  null
  
)

export default component.exports